import { render, staticRenderFns } from "./UserConfiguration.vue?vue&type=template&id=346b4c7c&scoped=true"
import script from "./UserConfiguration.vue?vue&type=script&lang=js"
export * from "./UserConfiguration.vue?vue&type=script&lang=js"
import style0 from "./UserConfiguration.vue?vue&type=style&index=0&id=346b4c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b4c7c",
  null
  
)

export default component.exports